import React from "react";
import { Survey, Question } from "./survey-types";
import QuestionTypeIcon from "./QuestionTypeIcon";

interface SurveyDefinitionProps {
  survey: Survey;
}

const SurveyDefinition: React.FC<SurveyDefinitionProps> = ({ survey }) => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-xl">Survey goals</h3>

      <div className="p-4 bg-slate-800 mb-6">
        <p className="">{survey.header?.contextAndObjectives}</p>
        {!survey.header?.contextAndObjectives && (
          <p className="italic text-slate-400">
            No context and objectives provided.
          </p>
        )}
      </div>

      <h3 className="text-xl">Target Audience</h3>

      <div className="p-4 bg-slate-800 mb-6">
        {survey.demographicTarget?.targetAudience && (
          <div className="mb-12 mt-4">
            <div className="mb-12">
              <p className="mb-4">{survey.demographicTarget.targetAudience}</p>
              {!survey.demographicTarget?.targetAudience && (
                <p className="italic text-slate-400">
                  No target audience provided.
                </p>
              )}
            </div>
          </div>
        )}
      </div>

      <h3 className="text-xl">Questions</h3>

      <ul className="flex flex-col gap-4">
        {survey.questions.map((question, index) => (
          <li key={question.id} className="p-4 bg-slate-800">
            <div className="mb-4">
              <span className="bg-[#38bdf9] rounded px-1 inline-block">
                {index + 1}. &nbsp;
                <QuestionTypeIcon type={question.type} />
              </span>{" "}
              &nbsp;
              <span className="font-semibold">{question.text}</span>
              {question.required && <span className="text-red-500">*</span>}
            </div>
            {displayQuestionDefinition(question)}
          </li>
        ))}
      </ul>
    </div>
  );
};

const displayQuestionDefinition = (question: Question) => {
  switch (question.type) {
    case "multiple-choice":
      return (
        <div className="">
          Choices:
          <ul className="ml-4">
            {question.choices.map((choice, index) => (
              <li key={index}>- {choice.text}</li>
            ))}
          </ul>
        </div>
      );
    case "text":
      return <p className="ml-4">Free text question</p>;
    case "yes-no":
      return (
        <div className="ml-8 mt-4 mb-4">
          Choices:
          <ul className="mt-2 ml-4">
            <li>- Yes</li>
            <li>- No</li>
          </ul>
        </div>
      );
    case "opinion-scale":
      return (
        <p className="ml-4">
          {question.minLabel} ({question.min}) - {question.maxLabel} (
          {question.max})
        </p>
      );
    case "ranking":
      return (
        <div className="ml-8 mt-4 mb-4">
          Choices to rank:
          <ul className="mt-2 ml-4">
            {question.choices.map((choice, index) => (
              <li key={index}>- {choice.text}</li>
            ))}
          </ul>
        </div>
      );
    case "number":
      return <p className="ml-4">Number question</p>;
    default:
      return "TODO - Display for this type of question not implemented";
  }
};

export default SurveyDefinition;
